import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=0b6b7fbc&scoped=true&"
import script from "./checkout.vue?vue&type=script&lang=js&"
export * from "./checkout.vue?vue&type=script&lang=js&"
import style0 from "./checkout.css?vue&type=style&index=0&id=0b6b7fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b7fbc",
  null
  
)

export default component.exports